import { Suspense, lazy, useEffect } from 'react';
import { Platform } from 'react-native';

import { SplashScreen, ErrorBoundary } from '@pletly/ui';
import { useUser } from '%context';
import { useSetSentryUser } from '%services/sentry/useSetSentryUser';
import { idfaSegmentPlugin } from '%services/analytics/client';
import { PwaPrompt } from '%components/PwaPrompt/PwaPrompt';
import LinkingConfiguration from '../navigation/LinkingConfiguration';

const AuthenticatedApp = lazy(() => import('./AuthenticatedApp/Authenticated'));
const UnauthenticatedApp = lazy(() => import('./UnauthenticatedApp/Unauthenticated'));

export default function () {
	const user = useUser();
	useSetSentryUser();

	useEffect(() => {
		if (Platform.OS !== 'ios') {
			return;
		}

		setTimeout(() => {
			void idfaSegmentPlugin.requestTrackingPermission();
		}, 500);
	}, []);

	return (
		<ErrorBoundary>
			{user ? (
				<Suspense fallback={<SplashScreen noImage />}>
					<AuthenticatedApp />
					<PwaPrompt />
				</Suspense>
			) : (
				<Suspense fallback={<SplashScreen />}>
					<UnauthenticatedApp linkingConfiguration={LinkingConfiguration} />
				</Suspense>
			)}
		</ErrorBoundary>
	);
}
